/**
 * 我方加密
 */
import SmCrypto from './sm';
import SmConstant from './constant';
import SmUtil from './util';

const { nodePublicKey, privateKey, iv, merchantCode } = {
  'merchantCode': 'ocrTicket',
  'nodePublicKey': '0485fffabb793c6b26e2b73468014bb6b2b54606854770d606525ce08de5b3d108b54fcc4e76d96e711bc54172cf4a305907bf4fec7676c4e08527f0a015e55a31',
  'privateKey': '61c9fc61c9553b46132cdb30ad2db58cc5e047f7cb2cb2e0812c47e402e00d7c',
  'publicKey': '0457a5330aa49e5637789f235a2e360c8af734b6073e386355b3d84c0431284c00728d93263dd6d5c1ceadd1986872c043aca73d97a640c49735fb6952def44918',
  'iv': '72495377666166573663466839534e53'
};

export default {

  /**
   * 加密数据
   *
   * @param {string|object} data 待加密数据（utf8编码格式）
   * @returns 加密后hex编码的数据
   */
  sm2Encrypt: (data) => {
    let encryptData = SmCrypto.sm2Encrypt(data, nodePublicKey, SmConstant.Mode.SM2.C1C2C3);
    return encryptData;
  },

  /**
   * 解密数据
   *
   * @param {string} data 待解密数据(hex编码格式)
   * @returns 解密后的数据
   */
  sm2Decrypt: (data) => {
    let decryptData = SmCrypto.sm2Decrypt(data, privateKey, SmConstant.Mode.SM2.C1C2C3);
    return decryptData;
  },

  /**
   * sm4加密
   *
   * @param {Object} data 待加密数据
   * @param {string} sm4Key 加密key(32位16进制字符串)
   * @param {string} iv 偏移(32位16进制字符串)
   * @returns {object} { encryptData, sm4Key }
   *  - encryptData: base64编码格式的加密数据
   *  - sm4Key: utf8编码格式的sm4key（java用）
   */
  sm4Encrypt: (data) => {
    const sm4Key = SmUtil.getSm4Key();
    const sm4KeyHex = Buffer.from(sm4Key).toString('hex');
    let encryptData = SmCrypto.sm4Encrypt(data, sm4KeyHex, {
      iv,
      mode: SmConstant.Mode.SM4.CBC
    });
    encryptData = Buffer.from(encryptData, 'hex').toString('base64');
    return { encryptData, sm4Key };
  },

  /**
   * sm4解密
   *
   * @param {string} data 加密数据（编码格式：base64）
   * @param {string} sm4KeyUtf8 java传给我们的
   * @returns
   */
  sm4Decrypt: (data, sm4KeyUtf8) => {
    const sm4KeyHex = Buffer.from(sm4KeyUtf8).toString('hex');
    data = Buffer.from(data, 'base64').toString('hex');
    const decryptData = SmCrypto.sm4Decrypt(data, sm4KeyHex, {
      iv,
      mode: SmConstant.Mode.SM4.CBC
    });
    return decryptData;
  },

  /**
   * 生成签名
   *
   * @param {string} data utf8格式待签名数据
   * @returns {string} base编码格式的签名
   */
  generalSignature: (data) => {
    const signDataBase64 = Buffer.from(data).toString('base64');
    let signature = SmCrypto.generalSignature(signDataBase64, privateKey, {
      der: true,
      hash: true,
      userId: merchantCode
    });
    signature = Buffer.from(signature, 'hex').toString('base64');
    return signature;
  },

  /**
   * 验签
   *
   * @param {string} data 待签名的utf8编码格式的字符串
   * @param {string} signature 签名（编码格式：base64）
   * @returns {boolean} [true | false]
   */
  verifySignature: (data, signature) => {
    const signDataBase64 = Buffer.from(data).toString('base64');
    const signatureHex = Buffer.from(signature, 'base64').toString('hex');
    return SmCrypto.verifySignature(signDataBase64, signatureHex, nodePublicKey, {
      der: true,
      hash: true,
      userId: merchantCode
    });
  }
};
